import React from 'react'
import type { IntlShape } from 'react-intl'

import type { useRoutes } from '../../routes'

export function getAboutBlogCards(
  intl: IntlShape,
  routes: ReturnType<typeof useRoutes>
) {
  return [
    {
      href: routes.blog.post({
        slug: 'super-story',
      }),
      imageSrc:
        'https://cdn.sanity.io/images/dnsgqii5/production/2691f8ba72896a63c662793c1a983bf90c5a7db2-2850x1719.png?auto=format&q=75&dpr=2',
      title: intl.formatMessage({
        defaultMessage:
          'How we built Super - The 1st reliable Enterprise Search',
        id: 'about.page.blogCards.title1',
      }),
      description: intl.formatMessage({
        defaultMessage:
          'Enterprise Search was broken. This is the story of how we fixed it in 1 year - and it all started from a hunch',
        id: 'about.page.blogCards.description1',
      }),
    },
    {
      href: routes.blog.post({
        slug: 'how-to-close-the-project-management-gap-with-slite-linear',
      }),
      imageSrc:
        'https://cdn.sanity.io/images/dnsgqii5/production/4e3435d8c26384f11b724a135c227e3c01813a10-3600x2160.jpg?auto=format&q=75&dpr=2',
      title: intl.formatMessage({
        defaultMessage:
          'How to close the project management gap with Slite & Linear',
        id: 'about.page.blogCards.title2',
      }),
      description: intl.formatMessage({
        defaultMessage:
          'A guide on how the Slite team uses Linear for project management while documenting in Slite as a Knowledge Base. ',
        id: 'about.page.blogCards.description2',
      }),
    },
  ]
}
